export default {
  name: 'button',
  type: 'action',
  isRequired: false,
  essential: false,
  data: {
    type: 'link', // link, submit, cart
    link: {
      type: 'outlink',
      url: 'http://',
      pageId: '0',
      target: false
    },
    submit: null,
    cart: null
  }
}
